import _XIcon from "@adsk/alloy-react-icon/es/lib/XIcon";
var _IconButton$propTypes;
const _excluded = ["style", "children", "disabled", "showEscapeLabel", "type", "renderIcon"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';
import { stylePropType } from '@adsk/alloy-react-theme';

/**
 * Close Button.
 */
const CloseButton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style,
      children,
      disabled = false,
      showEscapeLabel = true,
      type = 'button',
      renderIcon = _XIcon.renderIcon
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require(`./i18n/${locale}.json`);
  });
  const label = showEscapeLabel ? T.translate('CLOSE_ESC') : T.translate('CLOSE');
  return /*#__PURE__*/React.createElement(IconButton, _extends({
    ref: ref,
    "aria-label": label === null || label === void 0 ? void 0 : label.toString(),
    style: [{
      height: 24
    }, style],
    "data-testid": "close-button",
    disabled: disabled,
    type: type,
    renderIcon: renderIcon
  }, props));
});
CloseButton.displayName = 'CloseButton';
CloseButton.propTypes = {
  /** BasicButton's content */
  children: PropTypes.any,
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** button html type, eg: submit */
  type: (_IconButton$propTypes = IconButton.propTypes) === null || _IconButton$propTypes === void 0 ? void 0 : _IconButton$propTypes.type,
  /** Disable button functionality */
  disabled: PropTypes.bool,
  /** handle onclick event for button */
  onClick: PropTypes.func,
  /** Modify tooltip if Esc will be used to close */
  showEscapeLabel: PropTypes.bool
};
export default CloseButton;
//# sourceMappingURL=CloseButton.js.map